import { CropConfigs, useCroppedImage } from '@weee-fe/module';
import { useMemo } from 'react';

const useCroppedImageSet = ({ url, configs }: { url: string; configs?: CropConfigs }) => {
  const { getCroppedUrl } = useCroppedImage();

  const imgUrl = getCroppedUrl(url, { devicePixelRatio: 2, ...configs });

  const imgUrlSet = useMemo(() => {
    const url_1x = getCroppedUrl(url, { devicePixelRatio: 1, ...configs });
    const url_2x = imgUrl;
    const url_3x = imgUrl;
    return [url_1x, url_2x, url_3x];
  }, [url, configs, imgUrl, getCroppedUrl]);

  return {
    imgUrl,
    imgUrlSet
  };
};

export default useCroppedImageSet;
